import { render, staticRenderFns } from "./addCategory.modal.vue?vue&type=template&id=794017f5&"
import script from "./addCategory.modal.vue?vue&type=script&lang=js&"
export * from "./addCategory.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports